module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eI046"))).then(() => parcelRequire('hwSpx'));